import signedFetch from 'decentraland-crypto-fetch';
import * as nodeURL from 'url';
import { ClientError } from './ClientError';
const DEFAULT_RETRIES = 3;
const DEFAULT_RETRY_DELAY = 1000;
const DEFAULT_NON_RETRYABLE_STATUSES = [400, 401, 403, 404, 409, 422];
const URL = globalThis?.URL ?? nodeURL.URL;
export class BaseClient {
    baseUrl;
    retries;
    retryDelay;
    nonRetryableStatuses;
    identity;
    constructor(url, config) {
        this.baseUrl = url;
        this.identity = config?.identity;
        this.retries = config?.retries ?? DEFAULT_RETRIES;
        this.retryDelay = config?.retryDelay ?? DEFAULT_RETRY_DELAY;
        this.nonRetryableStatuses = config?.nonRetryableStatuses ?? DEFAULT_NON_RETRYABLE_STATUSES;
    }
    sleep = (delay) => new Promise(resolve => {
        setTimeout(resolve, delay);
    });
    getIdentity = () => this.identity instanceof Function ? this.identity() : this.identity;
    rawFetch = (path, init) => {
        const fullUrl = new URL(path, this.baseUrl);
        const identity = init?.identity ?? this.getIdentity();
        return signedFetch(fullUrl.toString(), { ...init, identity });
    };
    fetch = async (path, init) => {
        for (let attempt = 0; attempt <= this.retries; attempt++) {
            try {
                let response;
                let parsedResponse;
                try {
                    response = await this.rawFetch(path, init);
                    parsedResponse = await response.json();
                }
                catch (error) {
                    throw new ClientError(error.message, undefined, null);
                }
                if (!response.ok || parsedResponse.ok === false) {
                    const errorMessage = parsedResponse.message ?? parsedResponse.error;
                    throw new ClientError(errorMessage ??
                        `Request failed with status code ${response.status}`, response.status, parsedResponse.data);
                }
                if (parsedResponse.ok === true) {
                    return parsedResponse.data;
                }
                else {
                    return parsedResponse;
                }
            }
            catch (error) {
                console.error(`[API] HTTP request failed: ${error.message || ''}`, error);
                if (this.retries === attempt || (error.status && this.nonRetryableStatuses.includes(error.status)))
                    throw error;
                await this.sleep(this.retryDelay);
            }
        }
        throw new Error('Unreachable code');
    };
}
//# sourceMappingURL=BaseClient.js.map